import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: 'root'
})
export class Config {
    // you can change url and refer here to call API
    baseUrl = environment.developmentUrl;
    public authapiurl: string = this.baseUrl + "/api/auth/v2/login";
    public logoutapiurl: string = this.baseUrl + "/api/user/bshp/logout";
   // public checkphoneNumber:string=this.baseUrl+"/api/auth/checkPhoneNumberIsValid?phoneNumber=";

  public dashboardapiurl: string = this.baseUrl + "/api/lead/dashboard";
  public getdocument: string = this.baseUrl + "/api/lead/get-documents-and-licences-stage";
  public getAgencydocument: string = this.baseUrl + "/api/company/get-agency-document-info/agency/";
  public refreshToken: string = this.baseUrl + "/api/auth/refresh";
  public getLeadInfo:string=this.baseUrl+"/api/lead/get-lead-add-info";
  public updatePassword:string=this.baseUrl+"/api/user/password/update";

  public getdepartments:string=this.baseUrl+"/api/department/get-departments";
  public roleList:string=this.baseUrl+"/api/department/get-role-by-deprtment?departmentId=";
  // public setPassword:string=this.baseUrl+"/api/user/set/new/password";
  public setPassword:string=this.baseUrl+"/api/auth/password/set-password";
  public deleteDocument: string = this.baseUrl+"/api/thirdparty/lead/delete-document/";
  public deleteDocumentAgency: string = this.baseUrl+"/api/company/agency/delete-document/";
  public deleteLic: string = this.baseUrl+"/api/thirdparty/lead/delete-licence/";
  public deleteLicAgency: string = this.baseUrl+"/api/company/agency/delete-licence/";
  public deleteVoid: string = this.baseUrl+"/api/thirdparty/lead/delete-void-cheque/";
  public deleteVoidAgency: string = this.baseUrl+"/api/company/agency/delete-void-cheque/";
  public updateProfile: string = this.baseUrl+"/api/user/update/profile";

  public getContractInfo: string = this.baseUrl + "/api/thirdparty/get-contract-sign-of-lead/";
  public setnewPassword:string=this.baseUrl+"/api/auth/password/reset";
  public mgaSearch: string= this.baseUrl+"/api/lead/search-leads/mga/search/"

  public addMember:string=this.baseUrl+"/api/admin/register";
  public editMember:string=this.baseUrl+"/api/admin/update-user";
  public deleteMember:string=this.baseUrl+"/api/admin/remove-staff?userId=";
  public checkphoneNumber:string=this.baseUrl+"/api/auth/checkPhoneNumberIsValid?phoneNumber=";
  public checkEmail:string=this.baseUrl+"/api/auth/checkEmailInUse?email=";
  public getstaffMemberFilter:string=this.baseUrl+"/api/admin/get-staff-member";
  public getAllRoleList:string=this.baseUrl+"/api/department/get-roles";
  public forgetPassword:string=this.baseUrl+"/api/auth/password/resetlink";
  
  public getLeadList: string = this.baseUrl+ "/api/lead/get-leads-list";
  public getLeadMappingList: string = this.baseUrl+ "/api/lead/get-leads-mapping";
  public getMgaUnderLeads: string = this.baseUrl+ "/api/lead/v2/get-mga-under-leads";
  public getMgaUnderLeadsByPage: string = this.baseUrl+ "/api/lead/get-mga-under-leads?page=";
  public sizeWiseLeads: string = this.baseUrl+ "/api/lead/get-mga-under-leads?page=";

  public getAgencyList: string = this.baseUrl+ "/api/agency/get-agency-list";
  public getAgencyMapping: string = this.baseUrl+ "/api/agency/get-agency-mapping/";
  public uploadAgency:string=this.baseUrl+"/api/agency/upload-agency-csv";
  public uploadLeads:string=this.baseUrl+ "/api/lead/upload-leads-csv";
  public getLeadMapping:string=this.baseUrl+"/api/lead/get-leads-mapping/";
  public getAllHistory:string=this.baseUrl+"/api/import/get-all-import-history";



  public getDocumentDetails: string = this.baseUrl+ "/api/lead/get-lead-document-info-by-complience/"
  public getEODocumentmga:string=this.baseUrl+"/api/lead/upload-lead-documents-by-complience";
  public getLicDocumentmga:string=this.baseUrl+"/api/lead/upload-lead-licences-by-complience";
  public uploadVoidChequemga: string = this.baseUrl+"/api/lead/v2/upload-void-cheque-by-complience";
  
  
  
  public getEODocumentbroker:string=this.baseUrl+"/api/lead/upload-lead-documents-by-broker";
  public getLicDocumentbroker:string=this.baseUrl+"/api/lead/upload-lead-licences-by-broker";
  public uploadVoidChequebroker: string = this.baseUrl+"/api/lead/v2/upload-void-cheque-by-broker";
  
  public getEODocument:string=this.baseUrl+"/api/lead/upload-lead-documents";
  public getLicDocument:string=this.baseUrl+"/api/lead/upload-lead-licences";
  public uploadVoidCheque: string = this.baseUrl+"/api/lead/v2/upload-void-cheque";
  
  public updateLEad:string=this.baseUrl+"/api/lead/update-Lead-imformation";
  public updateAllDocument:string=this.baseUrl+"/api/lead/upload-documents-and-licences";
  public saveAllDocument:string=this.baseUrl+"/api/lead/save-document-and-licences-stage/";
 
  public getContractSignOFLead:string=this.baseUrl+"/api/thirdparty/get-contract-sign-of-lead/";
  public authsmarterUserapiurl: string = this.baseUrl + "/api/thirdparty/authorize-smarteru-user";
  public getTagsList: string= this.baseUrl + "/api/lead/search-tags";
  public filterData: string = this.baseUrl + "/api/lead/get-filter-lead-data";
  public filterLeads: string = this.baseUrl + "/api/lead/filter-mga-under-leads"


  public getLeadAgentsCodes: string = this.baseUrl + "/api/underwriter/get-lead-agents-codes/"
  public getOnlineTrainingDetails: string = this.baseUrl+"/api/thirdparty/get-online-training-details/"



   // Agreement API URL
  public getSignerStatus:string=this.baseUrl+"/api/thirdparty/get-signer-status";
  public updateEverSignStatus:string=this.baseUrl+"/api/thirdparty/update-ever-sign-status";
//END

// Notification
public getNotification: string = this.baseUrl+"/api/notification/get-notifications";
public notificationRead: string = this.baseUrl+"/api/notification/read-notification/";
public readAllNotification: string = this.baseUrl+"/api/notification/read-all-notification";


public OverWriteEO: string = this.baseUrl + "/api/lead/overrite-eo-documents";
public OverWriteLicences: string = this.baseUrl + "/api/lead/overrite-licenes";
public OverWriteVoidCheque: string = this.baseUrl + "/api/lead/v2/overrite-void-cheque";

public PreviewLink: string = this.baseUrl+"/api/lead/get-preview-link/";

//AgencySignUp   
public uploadEoDOcAgency: string =  this.baseUrl+"/api/company/upload-eo-documents-for-agency";
public uploadLicensesAgency: string = this.baseUrl+"/api/company/upload-lead-licences";
public uploadVoidAgency: string=this.baseUrl+"/api/company/v2/upload-void-cheque";
public uploadVoidChequeOAAgency: string=this.baseUrl+"/api/company/v2/upload-void-cheque-by-broker";
public overriteVoidAgency: string=this.baseUrl+"/api/company/v2/overrite-void-cheque-of-agency";
public updateVoidAgency: string=this.baseUrl+"/api/company/v2/overrite-void-cheque-of-agency";
public updateEoDOcAgency: string=this.baseUrl+"/api/company/overrite-eo-documents-of-agency";
public updateLicenes: string=this.baseUrl+"/api/company/overrite-licenes";

public getLeadMiscellaneous: string = this.baseUrl + "/api/misc/get-miscellaneous-document/";
public LeadInfoId: string = this.baseUrl + "/api/lead/get-lead-by-id/";
public SharedLink: string = this.baseUrl + "/api/lead/get-preview-link/";
public getExpiredDocs: string = this.baseUrl + "/api/lead/v2/mga/get-expired-expiring-docs/";


public getDocumentDetailsOA: string = this.baseUrl+ "/api/lead/get-lead-document-info/"

public getProvinces: string = this.baseUrl + "/api/sales/get-provinces";
public getLanguages: string = this.baseUrl + "/api/sales/get-languages";

public postApistep1: string = this.baseUrl + "/api/sales/get-quote/step1";
public saveQuote: string = this.baseUrl + "/api/sales/save-policy-as-quote";
public postApistep2: string = this.baseUrl + "/api/sales/get-quote/step2";
public postApistep3: string = this.baseUrl + "/api/sales/get-quote/step3";
public getCountry: string = this.baseUrl + "/api/sales/get-country-list";
public AddressCallCanada: string =  "https://api.mapbox.com/autofill/v1/suggest/";
public AddressCallCanadaSelect: string = "https://api.mapbox.com/autofill/v1/retrieve/";

public mgaSearchDocument: string= this.baseUrl+"/api/lead/mga/search-expired-expiring-docs/"
public getMoreInfoData: string = this.baseUrl + "/api/lead/v2/mga/more-info-req/get-expired-expiring-docs/";
public mgaSearchDocumentMoreInfo: string= this.baseUrl+"/api/lead/mga/more-info-req/search-expired-expiring-docs/"
public getLicenseRequested: string = this.baseUrl + "/api/document/v2/broker/get-requested-documents/";

public getLicDocumentRequested:string=this.baseUrl+"/api/document/upload-lead-licences";
public mgaSearchGlobal: string= this.baseUrl+"/api/lead/search-leads/mga/search/"

public uploadLicensOA: string = this.baseUrl+"/api/lead/upload-lead-licences-by-broker"
public uploadLicensOACompany: string = this.baseUrl+"/api/company/upload-lead-licences-by-broker"

public uploadEoOA: string = this.baseUrl+"/api/lead/upload-lead-documents-by-broker"
public uploadEoOACompany: string = this.baseUrl+"/api/company/upload-Agency-documents-by-broker"

public exportLeads: string = this.baseUrl+"/api/import/officeadmin/export-lead-list"
public getPoliciesHome: string = this.baseUrl+"/api/salesadmin/get-policy"
public getPoliciesSearch: string = this.baseUrl+"/api/salesadmin/search-policy"
public getTokenApiForPayment: string = this.baseUrl + "/api/sales/get-transaction-token"
public getAllPolicyForSalesAdmin: string = this.baseUrl + "/api/salesadmin/get-policy";
public getAllPolicyForSalesAdminByAgentId: string = this.baseUrl + "/api/salesadmin/get-policy-by-agent-id/";
// public postBuyPolicy: string = this.baseUrl + "/api/sales/buy-policy";
public getAllSavedQuotes: string = this.baseUrl + "/api/salesadmin/get-quote";
public getAllSavedQuotesByAgentId: string = this.baseUrl + "/api/salesadmin/get-quote-by-agent-id";
public getSavedQuotesById: string = this.baseUrl + "/api/salesadmin/get-quote-by-id/";
public getFilterSearchPolicyCall: string = this.baseUrl + "/api/salesadmin/v2/tl/search-policy";
public getPolicyByIdSelected: string = this.baseUrl + "/api/salesadmin/get-policy-by-id/";
public getPolicyEmailSend: string = this.baseUrl + "/api/salesadmin/send-email-of-coc";
public getPolicyCoc1: string = this.baseUrl + "/api/salesadmin/view-policy-coc/";
public getRefundTxnApi: string = this.baseUrl + "/api/salesadmin/refund-policy";


public getUnderwriterLeadAgentCode: string = this.baseUrl + "/api/underwriter/get-lead-agents-codes";
public updateAgreementStatus: string = this.baseUrl + "/api/ever/update-agreement-status/";
public getAllAgencyMgas: string = this.baseUrl + "/api/agency/get-agency-mga";

public viewCOC: string = this.baseUrl + "/api/salesadmin/view-policy-coc/";
public editBilling: string = this.baseUrl + "/api/salesadmin/update-policy-credit-card";
public getPolicyByIdSalesAdmin: string = this.baseUrl + "/api/salesadmin/get-policy-by-id/";
public addNoteInPolicy: string = this.baseUrl + "/api/salesadmin/add-note-in-policy";
public getNotesStatus: string = this.baseUrl + "/api/policy/get-notes-status";
public upadtePolicyInformation:string = this.baseUrl +  "/api/salesadmin/update-policy-information"
public changePolicy: string = this.baseUrl + "/api/salesadmin/v3/change-policy";
public PostChangePolicy:string = this.baseUrl + "/api/salesadmin/get-change-policy";
public getProvinceByBrokerId:string = this.baseUrl + "/api/sales/get-licenced-province/";
public getAllPolicyForSalesAdminBySize: string = this.baseUrl + "/api/salesadmin/get-policy?page";
public acceptAddendumAgentID: string = this.baseUrl + "/api/agentcode/accept-addendum-agent-id";
public generateTokenApiForPayment: string = this.baseUrl + "/api/sales/generate-transaction-token"

public brokerSalesPdf: string = this.baseUrl + "/api/pdf/broker-Sales";
public brokerCommissionPdf: string = this.baseUrl + "/api/pdf/broker-Commission";
public mgaCommissionPdf: string = this.baseUrl + "/api/pdf/mga-Commission";
public mgaCommissiontoBrokerPdf: string = this.baseUrl + "/api/pdf/mga-Commission-to-broker";
public salesReportSummary: string = this.baseUrl + "/api/pdf/v2/reports-summary";
public savePolicyQuoteAndEmail: string = this.baseUrl + "/api/sales/save-policy-as-quote-and-print-email";
public sendEmailOfSavedQuotes: string = this.baseUrl + "/api/salesadmin/send-email-of-saved-quote";
public getPolicyHomePage: string = this.baseUrl + "/api/salesadmin/v2/search-policy";
public deletePolicy: string = this.baseUrl+"/api/policy/delete-policy";
public PreviewLinkSales: string = this.baseUrl+"/api/sales/get-policy-wording-file";
public getpolicyAsQuoteAndPrintEmail: string = this.baseUrl+"/api/salesadmin/get-policy-as-quote-and-print-email/";
public searchQuote: string = this.baseUrl+"/api/salesadmin/tl/quote/search-policy";
public filterSavedQuote: string = this.baseUrl+"/api/salesadmin/tl/quote/search-policy-with-filter";
public postApiVTCstep1: string = this.baseUrl + "/api/sales/vtc/get-quote/step1";
  public postVTCBuyPolicy: string = this.baseUrl + "/api/sales/vtc/buy-policy";


//-------------------------Report module
public v2BrokerCommission: string = this.baseUrl+"/api/pdf/v2/broker-commission";
public getCommissionStatementDates: string = this.baseUrl+"/api/salesadmin/broker/get-commission-statement-dates";
public v2BrokerSales: string = this.baseUrl+"/api/pdf/v2/broker-Sales";
public v2MgaCommission: string = this.baseUrl+"/api/pdf/v2/mga-commission";
public v2MgaSales: string = this.baseUrl+"/api/pdf/v2/mga-Sales";
public v2AgencyCommission: string = this.baseUrl+"/api/pdf/v2/agency-commission";
public v2AgencySales: string = this.baseUrl+"/api/pdf/v2/agency-Sales";
public getCountryWithCode: string = this.baseUrl+"/api/sales/v2/get-country-list";
public applicationBoxFile: string = this.baseUrl+"/api/sales/application/get-box-file";
public refundBoxFile: string = this.baseUrl+"/api/sales/refund/get-box-file";
public getProvinceByAgentId:string = this.baseUrl + "/api/sales/v2/get-licenced-province/";
public getClaimBoxFile:string = this.baseUrl + "/api/sales/claim/get-box-file"

public downloadFile: string = this.baseUrl+"/api/thirdparty/download-file?document_hash=";
public mgaCommissionBrokerForOVR:string = this.baseUrl + "/api/pdf/v3/mga-commission";
public mgaOvrSalesbyBroker:string = this.baseUrl + "/api/pdf/v3/mga-ovr-sales-by-broker";
public mgaOvrcommission:string = this.baseUrl + "/api/pdf/v2/mga-ovr-commission";
public verifyToken:string = this.baseUrl + "/api/auth/verify-token?token=";
public getFilterSearchPolicyCallNew: string = this.baseUrl + "/api/salesadmin/v2/tl/search-policy";
public PreviewLinkVtc: string = this.baseUrl+"/api/sales/vtc/get-policy-wording-file";
public sendOtpForVoidCheque: string = this.baseUrl+"/api/thirdparty/send-otp-to-verify-void-cheque";
public verifyOtpForVoidCheque: string = this.baseUrl+"/api/thirdparty/verify-otp-to-verify-void-cheque";
public DocmoreInfoReq: string = this.baseUrl+"/api/lead/check-broker-documnet-more-info-requested";
public sendPaymentLink: string = this.baseUrl + "/api/salesadmin/send-payment-link";
public verifyTokenAndGetDetails: string = this.baseUrl + "/api/payment/verify-token-and-get-details?token=";
public paymentLinkPay: string = this.baseUrl + "/api/payment/policy/pay";
public getPolicyDocsByPolicyId: string = this.baseUrl + "/api/sales/get-policy-docs/"
public checkAlreadyAuthoriseForVoidCheque: string = this.baseUrl+"/api/thirdparty/check-already-authorise";
// public sendOtpForVoidCheque: string = this.baseUrl+"/api/thirdparty/send-otp-to-verify-void-cheque";
// public verifyOtpForVoidCheque: string = this.baseUrl+"/api/thirdparty/verify-otp-to-verify-void-cheque";

public postBuyPolicy: string = this.baseUrl + "/api/sales/v3/buy-policy";
// public checkAlreadyAuthoriseForVoidCheque: string = this.baseUrl+"/api/thirdparty/check-already-authorise"
public checkPaymentAmount: string = this.baseUrl + "/api/payment/check-amount?amount="
public getLeadInfoNew: string = this.baseUrl + "/api/lead/v2/get-lead-add-info";
public getProvince: string = this.baseUrl + "/api/master/get-provinces";
public changeUserPassword: string = this.baseUrl + "/api/auth/change-user-password";
public changeOldPassword: string = this.baseUrl + "/api/auth/change-expire-password";
// public DocmoreInfoReq: string = this.baseUrl+"/api/lead/check-broker-documnet-more-info-requested";
public deletedocumentMga: string = this.baseUrl + "/api/lead-documents/delete-document/";
public getMGAdocument: string = this.baseUrl + "/api/lead-documents/get-documents-by-complience/type/";
public v2AddUpdateBroker: string = this.baseUrl + "/api/lead-documents/v2/add-or-update-broker";
public updateMGAShortName: string = this.baseUrl + "/api/mga/update-mga-name";
public checkLinkValid: string = this.baseUrl + "/api/auth/check-password-change-token-valid/";
// payment module
public paymentModule: string = this.baseUrl + "/api/payment/pay/owing-amount";
public getPaymentModuleDetails: string = this.baseUrl + "/api/payment/get-opening-balance-status/";
public getPaymentHistory: string = this.baseUrl + "/api/payment/v3/get-payment-history/";
public getTransferAgencyCode: string = this.baseUrl + "/api/payment/get-all-agent-codes-oflead-with-owing/";
public acceptBrokerStatement: string = this.baseUrl + "/api/user/accept-broker-statement";
public downloadLeadsDocs: string = this.baseUrl + "/api/thirdparty/download-leads-document-zip-file/";
public getLastTrainingDate: string = this.baseUrl + "/api/training/get-last-training-date/"
public getVtcQuotes: string = this.baseUrl + "/api/salesadmin/get-vtc-quotes-by-agent-id";
public calculatePremium: string = this.baseUrl + "/api/quote/calculate-vtc-premium";
public getSavedQuotesByIdVTC: string = this.baseUrl + "/api/salesadmin/vtc/get-quote-by-id/";
public getVTCPlanNames: string = this.baseUrl + "/api/quote/get-vtc-plan/";
public OADeactivateBrokerleads: string = this.baseUrl + "/api/lead/oa/deactivate-broker";
public OADeactivateBrokerleadsMultiple: string = this.baseUrl + "/api/lead/oa/deactivate-broker";
public acceptisprates: string = this.baseUrl + "/api/user/accept-isp-rates-acknowledged";
public MgaOVRBalanceOwing: string = this.baseUrl + "/api/payment/get-mga-override-owing-balances/";
public acceptPortalAnnouncement: string = this.baseUrl + "/api/user/accept-portal-announcement";
public verifyBrokerBypassLogin: string = this.baseUrl + "/api/user/accept-portal-announcement";
public bypassLogin: string = this.baseUrl + "/api/impersonate/verify-broker";
// public dashboardapiurl1: string = this.baseUrl + "/api/lead/dashboard";
// public DocmoreInfoReq1: string = this.baseUrl+"/api/lead/check-broker-documnet-more-info-requested";
public v2GetRequestedDocumentAddUpdate: string = this.baseUrl + "/api/document/v2/add-or-update-broker";
public addUpdateSIN: string = this.baseUrl + "/api/document/add-or-update-sin";
public addLeads: string = this.baseUrl + "/api/lead/add-new-lead";
public getV3RecaptchaVerification: string = this. baseUrl + "/api/auth/handle-captcha"
public annualTrainingConfirmation: string = this.baseUrl + "/api/training/training-attestation/status";
public annualTrainingConfirmationAction: string = this.baseUrl + "/api/training/training-attestation-action";
}